export const forumCategoriesActionType = {
  GET_FORUM_CATEGORIES: "get_forum_categories",
  GET_FORUM_CATEGORY_BY_ID: "get_forum_category_by_id",
  CLEAR_FORUM_CATEGORIES: "clear_forum_categories",
};
